var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4231 14C8.28503 14 8.1731 13.8881 8.1731 13.75C8.1731 13.6119 8.28503 13.5 8.4231 13.5",
    stroke: "#EB9700",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4231 14C8.56116 14 8.6731 13.8881 8.6731 13.75C8.6731 13.6119 8.56116 13.5 8.4231 13.5",
    stroke: "#EB9700",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4231 11.5V6.5",
    stroke: "#EB9700",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50376 2.17318C9.40456 1.97118 9.2507 1.80104 9.0597 1.68206C8.8687 1.56307 8.64816 1.5 8.4231 1.5C8.19803 1.5 7.9775 1.56307 7.7865 1.68206C7.5955 1.80104 7.44163 1.97118 7.34243 2.17318L1.0271 15.0385C0.951083 15.1932 0.915727 15.3646 0.924373 15.5367C0.93302 15.7088 0.985384 15.8759 1.07652 16.0221C1.16766 16.1684 1.29456 16.289 1.44526 16.3726C1.59594 16.4562 1.76545 16.5 1.93777 16.4998H14.9084C15.0808 16.5 15.2502 16.4562 15.401 16.3726C15.5516 16.289 15.6786 16.1684 15.7697 16.0221C15.8608 15.8759 15.9132 15.7088 15.9218 15.5367C15.9305 15.3646 15.8951 15.1932 15.8191 15.0385L9.50376 2.17318Z",
    stroke: "#EB9700",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending-icon.576a941caaecc8562363f846054942d0.svg";
export { ForwardRef as ReactComponent };